import { createContext, useCallback } from 'react'

interface LocalStorageContextValues {
    get: (key: string) => string | null
    save: (key: string, value: any) => void
}

export const LOCAL_STORAGE_CONTEXT = createContext<LocalStorageContextValues>({
    get: (key: string) => {
        return null
    },
    save: (key: string, value: string) => {},
})

export interface LocalStorageContextProps {
    children: React.ReactNode
}

export function LocalStorageContextProvider({
    children,
}: LocalStorageContextProps) {
    const get = useCallback((key: string) => {
        return localStorage.getItem(key)
    }, [])

    const save = useCallback((key: string, value: any) => {
        localStorage.setItem(key, JSON.stringify({ value }))
    }, [])

    const context = { get, save }
    return (
        <LOCAL_STORAGE_CONTEXT.Provider value={context}>
            {children}
        </LOCAL_STORAGE_CONTEXT.Provider>
    )
}
